"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Text_1 = require("./Text");
const Switch_1 = require("./Switch");
const SliderComponent_1 = require("./SliderComponent");
const colors_1 = require("../styles/colors");
const TimePicker = ({ seconds, handleSecondsChange, containerStyle }) => {
    const minutes = Math.floor(seconds / 60) % 60;
    let hours = Math.floor(seconds / 3600) % 3600;
    const period = seconds - 12 * 3600 < 0 ? 'AM' : 'PM';
    if (period === 'PM') {
        hours = hours % 12;
    }
    return (React.createElement("div", { style: Object.assign({ height: 272 }, containerStyle) },
        React.createElement(Text_1.default, { size: "x-large", text: `${hours === 0 || hours === 12 ? 12 : hours % 12}:${minutes.toString().length === 1 ? `0${minutes}` : minutes} ${period}`, textStyle: { paddingBottom: 24 } }),
        React.createElement("div", { style: {
                paddingBottom: 24,
                display: 'flex',
                flexDirection: 'column',
            } },
            React.createElement(Text_1.default, { size: "medium", text: "Hour" }),
            React.createElement(SliderComponent_1.default, { min: 1, max: 12, value: (hours % 12) + 1, onChange: newHour => {
                    const convertedHour = newHour - 1;
                    const diffHours = convertedHour - hours;
                    handleSecondsChange(seconds + diffHours * 3600);
                }, containerStyle: {
                    width: '100%',
                } })),
        React.createElement("div", { style: {
                paddingBottom: 24,
                display: 'flex',
                flexDirection: 'column',
            } },
            React.createElement(Text_1.default, { size: "medium", text: "Minute" }),
            React.createElement(SliderComponent_1.default, { min: 0, max: 59, value: minutes, onChange: newMinute => {
                    const diffMinutes = newMinute - minutes;
                    handleSecondsChange(seconds + diffMinutes * 60);
                }, containerStyle: {
                    width: '100%',
                } })),
        React.createElement(Switch_1.default, { on: period === 'AM', style: {
                outerStyle: {
                    backgroundColor: period === 'AM' ? colors_1.steel : colors_1.graphite,
                    height: 22,
                },
                textStyle: {
                    lineHeight: '17px',
                },
            }, text: period, onClick: () => {
                if (period === 'PM') {
                    const s = minutes * 60 + (hours % 12) * 3600;
                    handleSecondsChange(s);
                }
                else {
                    const s = minutes * 60 + (hours + 12) * 3600;
                    handleSecondsChange(s);
                }
            } })));
};
TimePicker.defaultProps = {
    seconds: (() => {
        const dt = new Date();
        return 60 * dt.getMinutes() + 3600 * dt.getHours();
    })(),
};
exports.default = TimePicker;
